module.exports = __webpack_public_path__ + "static/media/img_overpaper3@2x.e00b5254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_overpaper3@2x.png
// module id = 964
// module chunks = 0